import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  SearchComponent,
  FooterComponent,
  TabbedComponent,
  CardSliderComponent,
  SliderComponent,
  DrawerComponent,
  NpSetLayoutDirective,
  NpSelectDirective,
  NpTableDirective,
  ValidNextPageRoutePipe,
  AlertComponent,
} from "@cvx/nextpage";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "./material.module";
import { SpinnerComponent } from "./shared/spinner/spinner.component";
import { ValidationComponent } from "./validation/validation.component";
import { ActionButtonComponent } from "./shared/action-button/action-button.component";
import { AdvancedFilterPanelComponent } from "./shared/advanced-filter-panel/advanced-filter-panel.component";
import { DataGridComponent } from "./shared/data-grid/data-grid.component";
import { CustomErrorComponent } from "./shared/error-page/custom-error-page.component";
import { NoAccessComponent } from "./shared/no-access/no-access.component";
import { IfInGroupDirective } from "./directives/if-in-group.directive";
import { UserSearchComponent } from "./shared/user-search/user-search.component";

const sharedComponents = [
  SearchComponent,
  FooterComponent,
  TabbedComponent,
  CardSliderComponent,
  SliderComponent,
  DrawerComponent,
  NpSetLayoutDirective,
  NpSelectDirective,
  NpTableDirective,
  ValidNextPageRoutePipe,
  AlertComponent,
  ActionButtonComponent,
  ValidationComponent,
  SpinnerComponent,
  AdvancedFilterPanelComponent,
  DataGridComponent,
  CustomErrorComponent,
  NoAccessComponent,
  IfInGroupDirective,
  UserSearchComponent,
];

@NgModule({
  declarations: [sharedComponents],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
  ],
  exports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    sharedComponents,
  ],
})
export class SharedModule {}
